export default "__VITE_ASSET__Cuc365Px__";